module.exports = __webpack_public_path__ + "img/part4-uIcon9.c56f2a16.png";